import {useNavigate} from "react-router-dom";
import {useQueryParams} from "@App/hooks/useQueryParams";

export const useNavigateWithQueryParams = () => {
    const navigate = useNavigate()
    const {createQuery} = useQueryParams()

    //navigateWithQuery has a param, that allows to toggle routing by path (the default is route)
    // With the update apparently navigation by route adds to the current route url, which is why
    // we now navigate relatively to the current path via "../abc"
    const navigateWithQuery = (path: string, navigateByPath?: boolean, query_params?: Record<string, string>) => {
        return navigate(path + createQuery(query_params), navigateByPath ? { relative: "path" } : {})
    }

    return {navigateWithQuery}
}


